import React, { Component, MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import Theme from '@interfaces/themes';

import './themes.css';

interface ThemesProps {
    items: Theme[];
    onThemeClick?(themeSlug?: string): void;
}

const class_ = b.with('themes');

class Themes extends Component<ThemesProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public onThemeClick = (event: MouseEvent, themeSlug?: string) => {
        const { onThemeClick } = this.props;

        if (onThemeClick) {
            event.preventDefault();
            onThemeClick(themeSlug);
        }
    };

    public render() {
        const { items } = this.props;

        return (
            <ul className={class_()}>
                {items.map(this.renderTheme)}
            </ul>
        );
    }

    private renderTheme = (theme: Theme) => {
        const url = `/publications?themeSlug=${theme.slug}`;
        const count = theme.publicationCount;

        /* tslint:disable:jsx-no-lambda-props */
        return (
            <li key={theme.slug} className={class_('item')}>
                <Link
                    className={class_('item-link')}
                    to={url}
                    onClick={(event: MouseEvent) => this.onThemeClick(event, theme.slug)}
                >
                    {theme.title}&nbsp;
                    {Boolean(count) && <span className={class_('item-count')}>{count}</span>}
                </Link>
            </li>
        );
    };
}

export default Themes;
